<template>
  <img
    v-if="!isError"
    :src="url"
    :alt="label"
    @error="isError = true"
    class="avatar avatar-sm rounded-lg"
  />
  <b-avatar
    v-else
    :text="label"
    class="avatar avatar-sm bg-exitos bg-exitos-5 text-exitos font-weight-bold"
    rounded="lg"
  />
</template>
<script setup>
import { shallowRef } from "vue";

const props = defineProps({
  url: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
});

const isError = shallowRef(false);
</script>
